import { useParams } from "@tanstack/react-router";

export default function usePulseId() {
    const { pulseId } = useParams({ from: "/_hub/$customerId/pulse/$pulseId" });
    if (!pulseId) {
        throw new Error("Pulse ID is not defined in the route parameters.");
    }
    return Number(pulseId);
}
